import { Component, Input } from '@angular/core';
import { BaseEdit } from '../base-edit';
import { VmpSelectionType } from '../../enums';
import { Observable, of } from 'rxjs';

@Component({
    selector: 'ldw-lookup-edit',
    templateUrl: './lookup-edit.component.html',
    styleUrls: ['./lookup-edit.component.css'],
    standalone: false
})
export class LookupEditComponent extends BaseEdit {
  @Input() clearButtonEnabled = true;
  @Input() AutoCompleteEnabled = false;

  autoCompleteValues: string[] | undefined = undefined;

  get autoCompleteItems$(): Observable<string[]> {
    if (this.autoCompleteValues != undefined) {
      return of(this.autoCompleteValues);
    }

    if (!this.isAutoComplete) {
      this.autoCompleteValues = [];
    } else {
      this.autoCompleteValues = []; // ['hello', 'test', 'blue'];
    }
    return of(this.autoCompleteValues);
  }

  get isAutoComplete(): boolean {
    if (this.AutoCompleteEnabled) {
      // control property overrides VMP property
      return true;
    }
    if (this.isBound) {
      return this.vmp?.selectionType == VmpSelectionType.AutoComplete;
    }
    return false;
  }

  clearText() {
    // this.clearErrorStates();
    this.internalControl?.reset('');
  }
}
